@if (!item.hidden) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a
      [id]="'navigation-' + item.id"
      [ngClass]="item.classes"
      [routerLink]="[item.url]"
      [routerLinkActive]="['active', 'primary']"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      class="nav-link"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a
      [href]="item.url"
      [id]="'navigation-' + item.id"
      [ngClass]="item.classes"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      class="nav-link"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span (click)="item.function()" [ngClass]="item.classes" class="nav-link">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a
      (click)="item.function()"
      [id]="'navigation-' + item.id"
      [ngClass]="item.classes"
      [routerLink]="[item.url]"
      [routerLinkActive]="['active', 'primary']"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      class="nav-link"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a
      (click)="item.function()"
      [href]="item.url"
      [id]="'navigation-' + item.id"
      [ngClass]="item.classes"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      class="nav-link"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon; as icon) {
      @if (icon.startsWith('svg')) {
        <mat-icon class="nav-link-icon" svgIcon="{{ icon }}"></mat-icon>
      } @else {
        <mat-icon class="nav-link-icon">{{ icon }}</mat-icon>
      }
    }
    @if (item.translate) {
      <span [translate]="item.translate" class="nav-link-title"></span>
    }
    @if (item.text) {
      <span class="nav-link-title">{{ item.text }}</span>
    }
    @if (item.badge) {
      <span
        [ngStyle]="{ 'background-color': item.badge.bg, color: item.badge.fg }"
        [translate]="item.badge.translate ?? ''"
        class="nav-link-badge"
      >
        {{ item.badge.title }}
      </span>
    }
  </ng-template>
}
